import {Component, OnInit} from "@angular/core";
import {NavigationStart, Router} from "@angular/router";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

    private readonly isHashUrl = /^\/#/

    public constructor(private readonly router: Router) {

    }

    /*
     * This is a dirty hack that exists purely because the TF UI code sends people to /#/signin and
     * since we run multiple skins on the same code we can't just update where that sends us
     */
    public ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if ((event.url != null) && this.isHashUrl.test(event.url)) {
                    const targetUrl = event.url.replace("/#", "")
                    window.location.assign(targetUrl)
                }
            }
        })
    }
}
